module.exports = __webpack_public_path__ + "ipetbooking-landing/img/logo-footer.c322f9d8.svg";